import React from 'react'
import { StyledSwitch } from './Switch.styles'

export const Switch = ({
  id,
  checked,
  onChange,
  onMouseDown,
  disabled,
}: {
  id: string
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onMouseDown?: React.MouseEventHandler<HTMLInputElement>
  disabled?: boolean
}): JSX.Element => {
  return (
    <StyledSwitch
      id={id}
      checked={checked}
      onChange={onChange}
      onMouseDown={onMouseDown}
      disabled={disabled}
    />
  )
}
